import React from 'react';
import Input from 'Components/Input';
import { ReactComponent as DeleteIcon } from "Icons/delete.svg";
import { ReactComponent as PlusIcon } from "Icons/new-plus.svg";
import { ReactComponent as CancelIcon } from 'Icons/cancel.svg';
import Dropdown from 'Components/Dropdown';
import Upload from 'Components/Upload';


const HandlingAgent = (props) => {
	const { multiModalMovementTypes, trip, tripIndex, onChangeTrip, pricingBasis, onDeleteTrip, openProviderPopup, onAddTrip, onDeleteTransporter, onUploadDoc, downloadUploadedFile, trips, container_trip_type } = props;
	let getLocation = () => {
		let location = '';
		if(container_trip_type == 2){
			location = trips[0].destination_yard || '';
		}else{
			location = ((trip.stops || [])[0] || {}).city;
		}
		return location
	}
    return (
        <div>
            <div className='flex flex-between'>
                <Input 
                    type="text" 
                    readOnly={true}
                    value={trip.provider_name}
                    className={"theme-color fs-18 fBold wt-250"}
                />
                <div>
					{(trip.docs || []).map(doc => <a onClick={() => downloadUploadedFile(doc.name)} className='mr-10 theme-color fs-16 fSemibold'>{doc.name}</a>)}
                    <Upload onChange={onUploadDoc.bind(this, tripIndex)} value="Upload File" accept=".pdf">
                        <button className={'ph-20 theme-color bg-white fBold br-5 ht-40 fs-16 border-theme mr-20'}> + Upload T & C </button>
                    </Upload>
                    <button className='ph-20 button-bg-color white-color fBold br-5 ht-40 fs-16' onClick={() => openProviderPopup(tripIndex, trip.provider_type)}>+ Add Provider</button>
                </div>
            </div>
			<div className='mt-10 flex flex-col'>
				<div className='border-light-blue-2 pv-10 ph-10 br-5 wt-95p'>
					<div className='flex mb-10'>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Location</div>
							<Input 
								type="text"
								value={getLocation()}
								readOnly={true}
							/>
						</div>
						<div className='wt-250 fSemibold mr-10'>
							<div className='fs-16 mb-5'>Movement Type</div>
							<Dropdown 
								items={multiModalMovementTypes}
								displayKey="name"
								selectedItem={(multiModalMovementTypes || []).find(el => el.id === trip.movement_type)}
								name="movement_type" 
								label="Select" 
								onSelect={(option) => props.onSelect(option, tripIndex, 'movement_type')}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Pricing Basis</div>
							<Dropdown
								items={pricingBasis}
								className={'bg-white'}
								displayKey="name"
								selectedItem={(pricingBasis || []).find(el => (el.name === trip.pricing_basis_name))}
								name="pricing_basis_name" 
								label="Select" 
								onSelect={(option) => props.onSelect(option, tripIndex, 'pricing_basis_name')}
							 />
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>LPP</div>
							<Input 
								type="number"
								value={trip.lpp}
                                disabled={true}
								onChange={(e) => onChangeTrip(e, tripIndex, 'lpp')}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Market Rate</div>
							<Input 
								type="number"
								value={trip.market_rate}
								onChange={(e) => onChangeTrip(e, tripIndex, 'market_rate')}
							/>
						</div>
					</div>
					<div className='flex'>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Ceiling Price</div>
							<Input 
								type="number"
								value={(trip['bidding_and_payments'] || {}).qbr}
								onChange={(e) => onChangeTrip(e, tripIndex, 'qbr')}
							/>
						</div>
						<div className='wt-220 fSemibold'>
							<div className='fs-16 mb-5'>Internal Remarks</div>
							<Input 
								value={trip.remarks}
								onChange={(e) => onChangeTrip(e, tripIndex, 'remarks')}
							/>
						</div>
					</div>
				</div>
				<div className='ml-10'>
					<div className='mt-40'><DeleteIcon className='wt-25 ht-25 curP' onClick={() => onDeleteTrip(tripIndex)}/></div>
					<div className='mt-40'><PlusIcon className='wt-25 ht-25 curP' onClick={() => onAddTrip()}/></div>
				</div>
			</div>
			{(trip.transporters_group || []).length > 0 && <div className='mt-10 border-light-blue-2'>
				<div className={'fs-16 fBold pv-10 ph-10'} style={{'background': '#D4E1FB'}}>Transporters</div>
				{(trip.transporters_group || []).map((transGroup, transGroupIndex) => (
					(transGroup.transporters || []).map((transporter, transporterIndex) => (
						<div className="fs-16 mb-10 inBlock border-bottom-light-2 tCenter mt-10 pv-5 pl-15 pr-15 br-15 ml-20" style={{'background': '#EEF3FD'}}>{transporter.name} <CancelIcon className='ml-5 mr-2 wt-15 ht-10 curP' fill='#EEF3FD' onClick={() => onDeleteTransporter(tripIndex, transGroupIndex, transporterIndex)}/></div>
					))
				))}
			</div>}
        </div>
    )
}

export default HandlingAgent;